module.exports = __webpack_public_path__ + "static/tabelle_neu2-48d0119cdc5e8ef9b0abcc58103f2aca.jpg";